import type { PipelineStepId, PipelineStepState } from '../types';

export type ExclusiveRunLock = {
  current: boolean;
};

export function tryBeginExclusiveRun(lock: ExclusiveRunLock): boolean {
  if (lock.current) {
    return false;
  }

  lock.current = true;
  return true;
}

export function endExclusiveRun(lock: ExclusiveRunLock): void {
  lock.current = false;
}

export function isAnyPipelineStepRunning(
  steps: Record<PipelineStepId, PipelineStepState>,
): boolean {
  return Object.values(steps).some((step) => step.status === 'running');
}
